<app-header></app-header>
<div class="principal-container">
  <div class="second-container">
    <h1 class="principal-title">Descubre proyectos</h1>
    <p class="descripcion">
      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Corporis et vero
      facilis Corporis et vero facilis. Corporis et vero facilis.
    </p>
  </div>

  <input class="search-input" placeholder="Buscar proyecto" />
  <div class="options-container">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="categoria-container">
          <p class="title-option">
            Categorías
          </p>
          <div class="img-category-container">
            <img
              mat-card-image
              src="../../../../assets/images/Render4_1.jpg"
              class="img-category"
            />
            <img
              mat-card-image
              src="../../../../assets/images/Render4_1.jpg"
              class="img-category"
            />
            <img
              mat-card-image
              src="../../../../assets/images/Render4_1.jpg"
              class="img-category"
            />
            <img
              mat-card-image
              src="../../../../assets/images/Render4_1.jpg"
              class="img-category"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="eventos-container">
      <p class="title-option-evento">
        Eventos
      </p>
      <div class="nav-container">
        <nav
          id="navbar"
          class="navbar full-width navbar-expand-lg navbar-light"
        >
          <div class="nav-bar-container">
            <ul class="navbar-nav mr-auto vertical-flex-align">
              <li class="nav-item">
                <a class="nav-anchor-li active-nav-item">
                  Recientes
                </a>
                <div class="line-option"></div>
              </li>
              <li class="nav-item">
                <a class="nav-anchor-li">
                  Más visitados
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-anchor-li">
                  Públicos
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-anchor-li">
                  Privados
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <div class="line-events"></div>

      <div class="cards-container">
        <div class="row">
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
          <div class="col">
            <div class="textos">
              <img
                mat-card-image
                src="../../../../assets/images/Render4_1.jpg"
                class="img-event"
              />
              <div class="event-name">Nombre del evento</div>
              <mat-icon class="icon-description">lock</mat-icon>
              <div class="event-desc">Descripción del evento</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
